module.exports = __webpack_public_path__ + "img/after1.ca7f5766.png";